export default function RemoveFromBrandIcon({ color = "#333333" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M14.4009 9.4781H6.01545C5.91519 9.4781 5.83316 9.56013 5.83316 9.66039V10.7541C5.83316 10.8544 5.91519 10.9364 6.01545 10.9364H14.4009C14.5011 10.9364 14.5832 10.8544 14.5832 10.7541V9.66039C14.5832 9.56013 14.5011 9.4781 14.4009 9.4781Z"
        fill={color}
      />
      <path
        d="M10.2083 0C4.57096 0 0 4.57096 0 10.2083C0 15.8457 4.57096 20.4167 10.2083 20.4167C15.8457 20.4167 20.4167 15.8457 20.4167 10.2083C20.4167 4.57096 15.8457 0 10.2083 0ZM10.2083 18.6849C5.528 18.6849 1.73177 14.8887 1.73177 10.2083C1.73177 5.528 5.528 1.73177 10.2083 1.73177C14.8887 1.73177 18.6849 5.528 18.6849 10.2083C18.6849 14.8887 14.8887 18.6849 10.2083 18.6849Z"
        fill={color}
      />
    </svg>
  );
}
